module.exports = require("babel-core/polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/babel/polyfill.js
// module id = 198
// module chunks = 0